/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import MessageStatus from './MessageStatus/index'
import MessageStatusUpdate from './MessageStatusUpdate/index'
import React from 'react'
import SentTime from './SentTime/index'
import User from './User/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/DesignSystem/CommsThread/Content/EventsTimeline/Content/Event/Types/Sms/Content/Outbound/Info"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Info.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<User
  viewPath={`${viewPath}/User`}
/>
<MessageStatus
  viewPath={`${viewPath}/MessageStatus`}
/>
<MessageStatusUpdate
  viewPath={`${viewPath}/MessageStatusUpdate`}
/>
<SentTime
  viewPath={`${viewPath}/SentTime`}
/>
</div>
{children}
</React.Fragment>)
}